module.exports = __webpack_public_path__ + "static/media/Brommer.e51ff68c.mp3";